module.exports = __webpack_public_path__ + "img/tab_img_m3.80bc073c.jpg";